function u32(bytes) {
    return new Uint32Array(bytes.buffer, bytes.byteOffset, Math.floor(bytes.byteLength / 4));
}

const isLittleEndian =
    new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
const BLACK = isLittleEndian ? 4278190080 : 255;

const SHA3_IOTA_H = [
    1, 32898, 32906, 2147516416, 32907, 2147483649, 2147516545, 32777, 138,
    136, 2147516425, 2147483658, 2147516555, 139, 32905, 32771, 32770, 128,
    32778, 2147483658, 2147516545, 32896, 2147483649, 2147516424,
];
const SHA3_IOTA_L = [
    0, 0, 2147483648, 2147483648, 0, 0, 2147483648, 2147483648, 0, 0, 0, 0,
    0, 2147483648, 2147483648, 2147483648, 2147483648, 2147483648, 0,
    2147483648, 2147483648, 2147483648, 0, 2147483648,
];

const FAST_STATE = new Uint8Array(200);
const FAST_STATE32 = u32(FAST_STATE);
let moveWorkerUrl = null;
let moveWorkerPool = null;

function hexToBytes(hex) {
    const normalized = String(hex).replace(/^0x/, "").padStart(64, "0");
    const bytes = new Uint8Array(32);
    for (let i = 0; i < 32; i += 1) {
        bytes[i] = parseInt(normalized.slice(2 * i, 2 * i + 2), 16);
    }
    return bytes;
}

function createBaseState(seed) {
    const state = new Uint8Array(200);
    state.set(hexToBytes(seed));
    state[64] = 1;
    state[135] = 128;
    return u32(state);
}

function byteSwap(value) {
    return (
        ((value << 24) & 4278190080) |
        ((value << 8) & 16711680) |
        ((value >>> 8) & 65280) |
        ((value >>> 24) & 255)
    );
}

function byteSwap32(values) {
    for (let i = 0; i < values.length; i += 1) {
        values[i] = byteSwap(values[i]);
    }
}

function setCounter(counter) {
    if (counter < 4294967296) {
        if (isLittleEndian) {
            FAST_STATE32[15] = byteSwap(counter);
            return;
        }

        FAST_STATE[63] = counter & 255;
        FAST_STATE[62] = (counter >>> 8) & 255;
        FAST_STATE[61] = (counter >>> 16) & 255;
        FAST_STATE[60] = (counter >>> 24) & 255;
        return;
    }

    for (let i = 63; counter > 0 && i >= 32; i -= 1) {
        FAST_STATE[i] = counter & 255;
        counter = Math.floor(counter / 256);
    }
}

function keccakPermutation(state) {
    for (let round = 0; round < 24; round += 1) {
        let c0 = state[0] ^ state[10] ^ state[20] ^ state[30] ^ state[40];
        let c1 = state[1] ^ state[11] ^ state[21] ^ state[31] ^ state[41];
        let c2 = state[2] ^ state[12] ^ state[22] ^ state[32] ^ state[42];
        let c3 = state[3] ^ state[13] ^ state[23] ^ state[33] ^ state[43];
        let c4 = state[4] ^ state[14] ^ state[24] ^ state[34] ^ state[44];
        let c5 = state[5] ^ state[15] ^ state[25] ^ state[35] ^ state[45];
        let c6 = state[6] ^ state[16] ^ state[26] ^ state[36] ^ state[46];
        let c7 = state[7] ^ state[17] ^ state[27] ^ state[37] ^ state[47];
        let c8 = state[8] ^ state[18] ^ state[28] ^ state[38] ^ state[48];
        let c9 = state[9] ^ state[19] ^ state[29] ^ state[39] ^ state[49];
        let d0 = ((c2 << 1) | (c3 >>> 31)) ^ c8;
        let d1 = ((c3 << 1) | (c2 >>> 31)) ^ c9;
        let d2 = ((c4 << 1) | (c5 >>> 31)) ^ c0;
        let d3 = ((c5 << 1) | (c4 >>> 31)) ^ c1;
        let d4 = ((c6 << 1) | (c7 >>> 31)) ^ c2;
        let d5 = ((c7 << 1) | (c6 >>> 31)) ^ c3;
        let d6 = ((c8 << 1) | (c9 >>> 31)) ^ c4;
        let d7 = ((c9 << 1) | (c8 >>> 31)) ^ c5;
        let d8 = ((c0 << 1) | (c1 >>> 31)) ^ c6;
        let d9 = ((c1 << 1) | (c0 >>> 31)) ^ c7;

        for (let i = 0; i < 50; i += 10) {
            state[i] ^= d0;
            state[i + 1] ^= d1;
            state[i + 2] ^= d2;
            state[i + 3] ^= d3;
            state[i + 4] ^= d4;
            state[i + 5] ^= d5;
            state[i + 6] ^= d6;
            state[i + 7] ^= d7;
            state[i + 8] ^= d8;
            state[i + 9] ^= d9;
        }

        let h = state[2];
        let l = state[3];
        let nh = (h << 1) | (l >>> 31);
        let nl = (l << 1) | (h >>> 31);
        h = state[20];
        l = state[21];
        state[20] = nh;
        state[21] = nl;
        nh = (h << 3) | (l >>> 29);
        nl = (l << 3) | (h >>> 29);
        h = state[14];
        l = state[15];
        state[14] = nh;
        state[15] = nl;
        nh = (h << 6) | (l >>> 26);
        nl = (l << 6) | (h >>> 26);
        h = state[22];
        l = state[23];
        state[22] = nh;
        state[23] = nl;
        nh = (h << 10) | (l >>> 22);
        nl = (l << 10) | (h >>> 22);
        h = state[34];
        l = state[35];
        state[34] = nh;
        state[35] = nl;
        nh = (h << 15) | (l >>> 17);
        nl = (l << 15) | (h >>> 17);
        h = state[36];
        l = state[37];
        state[36] = nh;
        state[37] = nl;
        nh = (h << 21) | (l >>> 11);
        nl = (l << 21) | (h >>> 11);
        h = state[6];
        l = state[7];
        state[6] = nh;
        state[7] = nl;
        nh = (h << 28) | (l >>> 4);
        nl = (l << 28) | (h >>> 4);
        h = state[10];
        l = state[11];
        state[10] = nh;
        state[11] = nl;
        nh = (l << 4) | (h >>> 28);
        nl = (h << 4) | (l >>> 28);
        h = state[32];
        l = state[33];
        state[32] = nh;
        state[33] = nl;
        nh = (l << 13) | (h >>> 19);
        nl = (h << 13) | (l >>> 19);
        h = state[16];
        l = state[17];
        state[16] = nh;
        state[17] = nl;
        nh = (l << 23) | (h >>> 9);
        nl = (h << 23) | (l >>> 9);
        h = state[42];
        l = state[43];
        state[42] = nh;
        state[43] = nl;
        nh = (h << 2) | (l >>> 30);
        nl = (l << 2) | (h >>> 30);
        h = state[48];
        l = state[49];
        state[48] = nh;
        state[49] = nl;
        nh = (h << 14) | (l >>> 18);
        nl = (l << 14) | (h >>> 18);
        h = state[8];
        l = state[9];
        state[8] = nh;
        state[9] = nl;
        nh = (h << 27) | (l >>> 5);
        nl = (l << 27) | (h >>> 5);
        h = state[30];
        l = state[31];
        state[30] = nh;
        state[31] = nl;
        nh = (l << 9) | (h >>> 23);
        nl = (h << 9) | (l >>> 23);
        h = state[46];
        l = state[47];
        state[46] = nh;
        state[47] = nl;
        nh = (l << 24) | (h >>> 8);
        nl = (h << 24) | (l >>> 8);
        h = state[38];
        l = state[39];
        state[38] = nh;
        state[39] = nl;
        nh = (h << 8) | (l >>> 24);
        nl = (l << 8) | (h >>> 24);
        h = state[26];
        l = state[27];
        state[26] = nh;
        state[27] = nl;
        nh = (h << 25) | (l >>> 7);
        nl = (l << 25) | (h >>> 7);
        h = state[24];
        l = state[25];
        state[24] = nh;
        state[25] = nl;
        nh = (l << 11) | (h >>> 21);
        nl = (h << 11) | (l >>> 21);
        h = state[4];
        l = state[5];
        state[4] = nh;
        state[5] = nl;
        nh = (l << 30) | (h >>> 2);
        nl = (h << 30) | (l >>> 2);
        h = state[40];
        l = state[41];
        state[40] = nh;
        state[41] = nl;
        nh = (h << 18) | (l >>> 14);
        nl = (l << 18) | (h >>> 14);
        h = state[28];
        l = state[29];
        state[28] = nh;
        state[29] = nl;
        nh = (l << 7) | (h >>> 25);
        nl = (h << 7) | (l >>> 25);
        h = state[44];
        l = state[45];
        state[44] = nh;
        state[45] = nl;
        nh = (l << 29) | (h >>> 3);
        nl = (h << 29) | (l >>> 3);
        h = state[18];
        l = state[19];
        state[18] = nh;
        state[19] = nl;
        nh = (h << 20) | (l >>> 12);
        nl = (l << 20) | (h >>> 12);
        h = state[12];
        l = state[13];
        state[12] = nh;
        state[13] = nl;
        nh = (l << 12) | (h >>> 20);
        nl = (h << 12) | (l >>> 20);
        h = state[2];
        l = state[3];
        state[2] = nh;
        state[3] = nl;

        for (let i = 0; i < 50; i += 10) {
            let a0 = state[i];
            let a1 = state[i + 1];
            let a2 = state[i + 2];
            let a3 = state[i + 3];
            let a4 = state[i + 4];
            let a5 = state[i + 5];
            let a6 = state[i + 6];
            let a7 = state[i + 7];
            let a8 = state[i + 8];
            let a9 = state[i + 9];
            state[i] ^= ~a2 & a4;
            state[i + 1] ^= ~a3 & a5;
            state[i + 2] ^= ~a4 & a6;
            state[i + 3] ^= ~a5 & a7;
            state[i + 4] ^= ~a6 & a8;
            state[i + 5] ^= ~a7 & a9;
            state[i + 6] ^= ~a8 & a0;
            state[i + 7] ^= ~a9 & a1;
            state[i + 8] ^= ~a0 & a2;
            state[i + 9] ^= ~a1 & a3;
        }

        state[0] ^= SHA3_IOTA_H[round];
        state[1] ^= SHA3_IOTA_L[round];
    }
}

function mod7FromState() {
    const b = FAST_STATE;
    return (
        b[0] * 4 + b[1] + b[2] * 2 + b[3] * 4 + b[4] + b[5] * 2 +
        b[6] * 4 + b[7] + b[8] * 2 + b[9] * 4 + b[10] + b[11] * 2 +
        b[12] * 4 + b[13] + b[14] * 2 + b[15] * 4 + b[16] + b[17] * 2 +
        b[18] * 4 + b[19] + b[20] * 2 + b[21] * 4 + b[22] +
        b[23] * 2 + b[24] * 4 + b[25] + b[26] * 2 + b[27] * 4 +
        b[28] + b[29] * 2 + b[30] * 4 + b[31]
    ) % 7;
}

function keccakMod7() {
    if (isLittleEndian) {
        keccakPermutation(FAST_STATE32);
        return mod7FromState();
    }

    byteSwap32(FAST_STATE32);
    keccakPermutation(FAST_STATE32);
    byteSwap32(FAST_STATE32);
    return mod7FromState();
}

function randomMod7(baseState, counter) {
    FAST_STATE32.set(baseState);
    setCounter(counter);
    return keccakMod7();
}

function moveCode(xRandom, yRandom) {
    return (
        (xRandom >= 4 ? 6 : xRandom >= 1 ? 0 : 3) +
        (yRandom >= 4 ? 2 : yRandom >= 1 ? 0 : 1)
    );
}

function fillMoveCodes(baseState, startPair, endPair, target, targetOffset) {
    let counter = 2 + 2 * startPair;
    for (let pair = startPair; pair < endPair; pair += 1) {
        target[targetOffset + pair - startPair] = moveCode(
            randomMod7(baseState, counter),
            randomMod7(baseState, counter + 1)
        );
        counter += 2;
    }
}

function getMoveWorkerUrl() {
    if (moveWorkerUrl) {
        return moveWorkerUrl;
    }

    const source = `
        const isLittleEndian = new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44;
        const SHA3_IOTA_H = ${JSON.stringify(SHA3_IOTA_H)};
        const SHA3_IOTA_L = ${JSON.stringify(SHA3_IOTA_L)};
        const FAST_STATE = new Uint8Array(200);
        const FAST_STATE32 = new Uint32Array(FAST_STATE.buffer, FAST_STATE.byteOffset, Math.floor(FAST_STATE.byteLength / 4));
        ${u32.toString()}
        ${hexToBytes.toString()}
        ${createBaseState.toString()}
        ${byteSwap.toString()}
        ${byteSwap32.toString()}
        ${setCounter.toString()}
        ${keccakPermutation.toString()}
        ${mod7FromState.toString()}
        ${keccakMod7.toString()}
        ${randomMod7.toString()}
        ${moveCode.toString()}
        ${fillMoveCodes.toString()}
        self.onmessage = function (event) {
            const data = event.data;
            const values = new Uint8Array(data.end - data.start);
            fillMoveCodes(createBaseState(data.seed), data.start, data.end, values, 0);
            self.postMessage({ offset: data.offset, values: values }, [values.buffer]);
        };
    `;

    moveWorkerUrl = URL.createObjectURL(new Blob([source], { type: "text/javascript" }));
    return moveWorkerUrl;
}

function canUseMoveWorkers(count) {
    return (
        count >= 4096 &&
        typeof window != "undefined" &&
        window.Worker &&
        window.Blob &&
        window.URL
    );
}

function moveWorkerCount(count) {
    return Math.min(
        navigator.hardwareConcurrency || 2,
        16,
        Math.ceil(count / 12288)
    );
}

function createMoveWorkerPool() {
    const workerUrl = getMoveWorkerUrl();
    const workerCount = Math.min(navigator.hardwareConcurrency || 2, 16);
    const queue = [];
    const workers = [];
    let disposed = false;

    const runNext = (entry) => {
        if (entry.current || disposed) {
            return;
        }

        const job = queue.shift();
        if (!job) {
            return;
        }

        entry.current = job;
        entry.worker.postMessage(job.payload);
    };

    for (let i = 0; i < workerCount; i += 1) {
        const entry = {
            worker: new Worker(workerUrl),
            current: null,
        };

        entry.worker.onmessage = (event) => {
            const job = entry.current;
            entry.current = null;
            if (job) {
                job.resolve(event.data);
            }
            runNext(entry);
        };

        entry.worker.onerror = (error) => {
            const job = entry.current;
            entry.current = null;
            if (job) {
                job.reject(error);
            }
            runNext(entry);
        };

        workers.push(entry);
    }

    return {
        enqueue(payload) {
            if (disposed) {
                return Promise.reject(new Error("Move worker pool disposed"));
            }

            return new Promise((resolve, reject) => {
                queue.push({ payload: payload, resolve: resolve, reject: reject });
                workers.forEach(runNext);
            });
        },

        dispose() {
            disposed = true;
            const error = new Error("Move worker pool disposed");
            queue.splice(0).forEach((job) => job.reject(error));
            workers.forEach((entry) => {
                if (entry.current) {
                    entry.current.reject(error);
                    entry.current = null;
                }
                entry.worker.terminate();
            });
        },
    };
}

function getMoveWorkerPool() {
    if (!moveWorkerPool) {
        moveWorkerPool = createMoveWorkerPool();
    }
    return moveWorkerPool;
}

function fillMoveCodesWithWorkers(seed, count, onProgress) {
    if (!canUseMoveWorkers(count)) {
        return null;
    }

    const workerCount = moveWorkerCount(count);
    if (workerCount < 2) {
        return null;
    }

    return new Promise((resolve, reject) => {
        const moves = new Uint8Array(count);
        const pool = getMoveWorkerPool();
        const jobs = [];
        let completed = 0;

        for (let i = 0; i < workerCount; i += 1) {
            const start = Math.floor((count * i) / workerCount);
            const end = Math.floor((count * (i + 1)) / workerCount);
            jobs.push(
                pool.enqueue({ seed: seed, start: start, end: end, offset: start })
                    .then((data) => {
                        const values = data.values;
                        moves.set(values, data.offset);
                        completed += values.length;
                        if (onProgress) {
                            onProgress(completed, count);
                        }
                    })
            );
        }

        Promise.all(jobs)
            .then(() => resolve(moves))
            .catch(reject);
    });
}

function moveCount(numCells) {
    return Math.max(Math.floor((numCells - 1) / 2), 0);
}

function setPixel32(pixels, x, y, size) {
    const rowOffset = y * size;
    pixels[rowOffset + x] = BLACK;
    pixels[rowOffset + size - 1 - x] = BLACK;
}

function paintMoveCodesToCanvas(moveCodes, size, canvas) {
    const ctx = canvas.getContext("2d");

    canvas.width = size;
    canvas.height = size;

    const imgData = ctx.createImageData(size, size);
    const pixels = u32(imgData.data);
    let x = Math.floor(size / 2);
    let y = x;
    const max = size - 1;

    setPixel32(pixels, x, y, size);

    for (let i = 0; i < moveCodes.length; i += 1) {
        const code = moveCodes[i];
        if (code < 3) {
            x = x > 0 ? x - 1 : max;
        } else if (code > 5) {
            x = x < max ? x + 1 : 0;
        }

        if (code % 3 === 0) {
            y = y > 0 ? y - 1 : max;
        } else if (code % 3 === 2) {
            y = y < max ? y + 1 : 0;
        }

        setPixel32(pixels, x, y, size);
    }

    ctx.putImageData(imgData, 0, 0);
    return canvas;
}

function drawMoveCodesCanvas(moveCodes, size) {
    return paintMoveCodesToCanvas(
        moveCodes,
        size,
        document.createElement("canvas")
    );
}

function nextFrame() {
    return new Promise((resolve) => {
        if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(resolve);
            return;
        }
        setTimeout(resolve, 0);
    });
}

function getSize(numCells) {
    return Math.max(Math.floor(Math.sqrt(Math.floor(numCells / 7 * 10)) / 2) * 2, 8);
}

function codeToOffset(code) {
    const x = code < 3 ? -1 : code > 5 ? 1 : 0;
    const y = code % 3 === 0 ? -1 : code % 3 === 2 ? 1 : 0;
    return [x, y];
}

function paintOffsetsToCanvas(offsets, canvas) {
    const ctx = canvas.getContext("2d");
    const numCells = offsets.length * 2 + 2;
    const size = getSize(numCells);

    canvas.width = size;
    canvas.height = size;

    const imgData = ctx.createImageData(size, size);
    const pixels = u32(imgData.data);
    let x = Math.floor(size / 2);
    let y = x;
    const max = size - 1;

    setPixel32(pixels, x, y, size);

    for (let i = 0; i < offsets.length; i += 1) {
        const offset = offsets[i];
        if (offset[0] === 1) {
            x = x < max ? x + 1 : 0;
        } else if (offset[0] === -1) {
            x = x > 0 ? x - 1 : max;
        }

        if (offset[1] === 1) {
            y = y < max ? y + 1 : 0;
        } else if (offset[1] === -1) {
            y = y > 0 ? y - 1 : max;
        }

        setPixel32(pixels, x, y, size);
    }

    ctx.putImageData(imgData, 0, 0);
    return canvas;
}

async function createMoveCodesAsync(seed, count, onProgress) {
    let moves = null;

    try {
        moves = await fillMoveCodesWithWorkers(seed, count, onProgress);
    } catch (error) {
        void error;
        moves = null;
    }

    if (!moves) {
        moves = new Uint8Array(count);
        const baseState = createBaseState(seed);
        const chunkSize = 65536;

        for (let start = 0; start < count; start += chunkSize) {
            const end = Math.min(start + chunkSize, count);
            fillMoveCodes(baseState, start, end, moves, start);
            if (onProgress) {
                onProgress(end, count);
            }
            await nextFrame();
        }
    }

    if (onProgress) {
        onProgress(count, count);
    }

    return moves;
}

export const drawCanvas = function (seed, numCells, size) {
    const count = moveCount(numCells);
    const moves = new Uint8Array(count);
    fillMoveCodes(createBaseState(seed), 0, count, moves, 0);
    return drawMoveCodesCanvas(moves, size);
};

export const draw = function (seed, numCells, size) {
    return drawCanvas(seed, numCells, size).toDataURL();
};

export const drawAsync = async function (seed, numCells, size, onProgress) {
    const count = moveCount(numCells);
    const moves = await createMoveCodesAsync(seed, count, onProgress);
    return drawMoveCodesCanvas(moves, size).toDataURL();
};

export const drawToCanvasAsync = async function (
    seed,
    numCells,
    size,
    canvas,
    onProgress
) {
    const count = moveCount(numCells);
    const moves = await createMoveCodesAsync(seed, count, onProgress);
    return paintMoveCodesToCanvas(moves, size, canvas);
};

export const disposeDrawWorkers = function () {
    if (moveWorkerPool) {
        moveWorkerPool.dispose();
        moveWorkerPool = null;
    }

    if (moveWorkerUrl) {
        URL.revokeObjectURL(moveWorkerUrl);
        moveWorkerUrl = null;
    }
};

export const addOffsets = function (seed, offsets, count) {
    const moves = new Uint8Array(count);
    fillMoveCodes(createBaseState(seed), offsets.length, offsets.length + count, moves, 0);
    for (let i = 0; i < moves.length; i += 1) {
        offsets.push(codeToOffset(moves[i]));
    }
    return offsets;
};

export const drawOffsetsToCanvas = function (offsets, canvas) {
    return paintOffsetsToCanvas(offsets, canvas);
};

export const drawWithOffsets = function (offsets) {
    return paintOffsetsToCanvas(offsets, document.createElement("canvas")).toDataURL();
};
